export default __webpack_public_path__ + "static/media/Ohpen_W.133e0f1a.png";